import React, { useEffect, useRef, useState } from "react";

const RendersDropdownItem = ({ index, item, getIcon, handleItemSelect, isOpen }) => {
  const textRef = useRef(null);
  const containerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (textRef.current && containerRef.current) {
      setIsOverflowing(textRef.current.scrollWidth > containerRef.current.clientWidth);
      console.log(textRef.current.scrollWidth, containerRef.current.clientWidth);
    }
  }, [isOpen, textRef, containerRef]);

  return (
    <li key={index} className="hover:bg-[#D5D4D4]" onClick={() => handleItemSelect(item)}>
      <div className="flex gap-2 items-center max-w-full">
        <div className="input__icon">
          <img
            className="w-[30px] max-w-[30px] min-w-[30px]"
            src={getIcon(item.emojie)}
            alt="icon"
          />
        </div>
        <h3 className="font-secondaryTitle text-2xl flex items-center flex-nowrap">{item.type}</h3>
        <div
          ref={containerRef}
          className="w-full overflow-hidden whitespace-nowrap relative items-center flex"
        >
          <p
            ref={textRef}
            className={`font-body text-[#6C6C6C] text-sm inline-block ${
              isOverflowing ? "animate-marquee" : ""
            }`}
          >
            {item.name}
          </p>
        </div>
      </div>
    </li>
  );
};

export default RendersDropdownItem;
